import { faChevronRight } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAccessibility } from '../../../../Store/contexts/AccessibilityContext';
import { sxDarkGreyBody } from '../../../../assets/styles/CommonSxProps';
import DefaultButton from '../../../../components/Accessibility/DefaultButton';
import DefaultTextBold from '../../../../components/Accessibility/DefaultTextBold';
import PageTitle from '../../../../components/Accessibility/PageTitle';
import VoltarButton from '../../../../components/Accessibility/VoltarButton';
import LoadingApp from '../../../../components/LoadingApp';
import ModalFeedBack from '../../../../components/ModalFeedBack';
import { Mensagem as Conversa } from '../../../../interfaces/entities/SaudeBemEstar/ChatComEquipeGC/Mensagem';
import { getConversasAbertas, getConversasConcluidas } from '../../../../services/SaudeBemEstar/GestaoDeCronicosService';
import './styles.css';
import { sxGreenTextButton } from './sxProps';
import ChatCard from '../../../../components/ChatComEquipe/ChatCard';
import { ChatTypeEnum } from '../../../../components/ChatComEquipe/ChatTypeEnum';

const Conversas: React.FC = () => {

  const [loading, setLoading] = useState<boolean>(false);
  const [modalFeedback, setModalFeedback] = useState<null | {
    icon?: 'error' | 'success' | 'warning', title?: string, textButton?: string, subTitle?: string,
    closeAction: () => void, showButtonModal: boolean, buttonAction?: () => void
  }>(null);
  const [conversasAbertas, setConversasAbertas] = useState<Conversa[]>([]);
  const [conversasConcluidas, setConversasConcluidas] = useState<Conversa[]>([]);
  const navigate = useNavigate();

  const accessibility = useAccessibility();

  const fetchConversas = async () => {
    setLoading(true);
    await fetchConversasAbertas();
    await fetchConversasConcluidas();
    setLoading(false);
  }

  const fetchConversasAbertas = async () => {
    const response = await getConversasAbertas();
    if (response?.status === 200) {
      const conversasAbertas = response.data;
      setConversasAbertas(conversasAbertas);
    } else {
      console.error(response);
      handleFetchConversationsError();
    }
  }

  const fetchConversasConcluidas = async () => {
    const response = await getConversasConcluidas();
    if (response?.status === 200) {
      setConversasConcluidas(response.data);
    } else {
      console.error(response);
      handleFetchConversationsError();
    }
  }

  const handleFetchConversationsError = () => {
    openModal('error', 'Erro', 'Ocorreu um erro ao buscar as conversas. Tente novamente mais tarde.',
      'Fechar', () => window.history.back(), () => window.history.back());
  }

  useEffect(() => {
    fetchConversas();
  }, []);

  const openModal = (
    icon: 'success' | 'warning' | 'error', title: string, subTitle: string, textButton: string, closeAction: () => void, buttonAction: () => void
  ) => {
    setModalFeedback({
      icon,
      title,
      subTitle,
      textButton,
      showButtonModal: true,
      closeAction: closeAction,
      buttonAction: buttonAction
    });
  }

  return (
    <>
      <LoadingApp showLoading={loading} text='Carregando...' />
      {!loading && 
      <div className='chat-infos-container'>
        <PageTitle text='Chat com equipe' />

        <Typography
          sx={sxDarkGreyBody} style={accessibility.textStyleAccessibility} tabIndex={0}
        >
          Entre em contato com a equipe do Gestão de Crônicos (GC).
        </Typography>

        {conversasAbertas?.length > 0 && <ChatCard conversa={conversasAbertas[0]} chatType={ChatTypeEnum.GC} />}

        <div className='chat-buttons-container'>
          <DefaultButton text='Iniciar nova conversa' onClick={() => navigate('/saudeBemEstar/gestaoDeCronicos/conversaEquipe/conversas/nova')} />
          {conversasAbertas.length > 1 &&
            <DefaultButton
              variant='text' sx={sxGreenTextButton}
              style={accessibility.textStyleAccessibility}
              onClick={() => navigate('/saudeBemEstar/gestaoDeCronicos/conversaEquipe/conversas/abertas')}

            >
              <u>ver todas as conversas em andamento</u>&nbsp;&nbsp;<FontAwesomeIcon icon={faChevronRight} />
            </DefaultButton>
          }
        </div>

        {conversasConcluidas.length > 0 &&
          <>
          <DefaultTextBold text='Histórico de conversas concluídas' large />
            {conversasConcluidas.slice(0, 5).map((conversa, index) => (
              <ChatCard key={index} conversa={conversa} chatType={ChatTypeEnum.GC} />
            )
            )}
            {conversasConcluidas.length > 5 &&
              <DefaultButton
                variant='text' sx={sxGreenTextButton}
                style={accessibility.textStyleAccessibility}
                onClick={() => navigate('/saudeBemEstar/gestaoDeCronicos/conversaEquipe/conversas/concluidas')}
              >
                <u>ver todas as conversas concluídas</u>&nbsp;&nbsp;<FontAwesomeIcon icon={faChevronRight} />
              </DefaultButton>
            }
          </>
        }
        <VoltarButton text='Voltar' onClick={() => navigate('/saudeBemEstar/gestaoDeCronicos')} />
      </div >
      }
      <ModalFeedBack
        showModal={!!modalFeedback}
        handleShowModal={modalFeedback?.closeAction}
        title={modalFeedback?.title as string}
        subTitle={modalFeedback?.subTitle as string}
        icon={modalFeedback?.icon as 'success' | 'error' | 'warning'}
        showButtonModal={modalFeedback?.showButtonModal}
        textButton={modalFeedback?.textButton as string}
        handleButtonModal={modalFeedback?.buttonAction}
      />
    </>
  )
}

export default Conversas;